// Check if personal or M/A website
const tylerSites = ['crosspointemd.org']

var centralApi = ''
if (tylerSites.includes(window.location.hostname.replace('www.', ''))) centralApi = 'https://api.tylerewillis.com'
else centralApi = 'https://api.mullinashley.com'

export default centralApi